import { render, staticRenderFns } from "./upload-multiple-file.vue?vue&type=template&id=31edc538&"
import script from "./upload-multiple-file.vue?vue&type=script&lang=js&"
export * from "./upload-multiple-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports